import DynamicForm from '../../components/forms/DynamicForm';

function AddNew({ section, selectedTerm, currentTerm }) {
  const schoolId = localStorage.getItem('schoolId');
  const canAddRecord = selectedTerm?.id && selectedTerm.id === currentTerm?.id && selectedTerm.status === 'active';

  if (!canAddRecord) {
    return (
      <div className="max-w-5xl rounded-xl border border-blue-100 bg-blue-50 px-5 py-4 text-sm font-medium text-blue-700 dark:border-blue-800 dark:bg-neutral-900 dark:text-blue-300">
        Switch back to the current active term before adding new records. Previous terms are available for viewing and export only.
      </div>
    );
  }

  return (
    <DynamicForm
      section={section}
      schoolId={schoolId}
      termId={selectedTerm.id}
    />
  );
}

export default AddNew;
